import moment from 'moment';

export function displayDate(date: string | number | Date): string {
    let now = moment(date);
    return now.locale('ru').fromNow();
}
